import { t } from "@bookingcom/lingojs-react";
import useRouteName from "../../hooks/useRouteName";
import { useSelector } from "react-redux";
import { getSearch } from "../../store/search/selectors";
import { getFlight } from "../../store/flightDetails/selectors";
import flights_apex_web_bf_baggage_per_person from "../../utils/experiments/apex/flights_apex_web_bf_baggage_per_person";
import useUserAgent from "../../hooks/useUserAgent";
import useIsPostBookingRoute from "../../hooks/useIsPostBookingRoute";
import { useHasInfantTraveller } from "../../hooks/useHasInfantTraveller";

export const useGetFareFeaturesSubtitleCopy = () => {
  const { isMobile } = useUserAgent();
  const search = useSelector(getSearch);
  const flight = useSelector(getFlight);
  const routeName = useRouteName();
  const isSearchResults = routeName === "searchresults";
  const isCheckAndPay = routeName === "checkout-payment";
  const isBrandedFare = routeName === "checkout-fare";
  const isPostBooking = useIsPostBookingRoute();

  const totalTravellersOnSearch = (search.adults || 0) + (search.children || []).length;
  const totalTravellersOnFunnel = (flight?.travellers && flight?.travellers?.length) || 0;
  const hasMultipleTravellers = totalTravellersOnSearch > 1 || totalTravellersOnFunnel > 1;
  const hasInfant = useHasInfantTraveller();

  if (hasMultipleTravellers)
    flights_apex_web_bf_baggage_per_person.trackStages(
      isMobile,
      !!hasInfant,
      isSearchResults,
      isBrandedFare,
      isCheckAndPay,
      isPostBooking
    );

  const forAllTravellersVariant =
    hasMultipleTravellers && flights_apex_web_bf_baggage_per_person.trackWithDefaultStage() === 1;
  const forEachTravellerVariant =
    hasMultipleTravellers && flights_apex_web_bf_baggage_per_person.trackWithDefaultStage() === 2;

  const baseCopy = isCheckAndPay ? t("flights_pb_fare_subheader") : t("flight_fare_included");

  const headerCopy = forAllTravellersVariant
    ? t("flights_bf_included_total")
    : forEachTravellerVariant
    ? t("flights_bf_included_each")
    : baseCopy;

  return {
    headerCopy,
    forEachTravellerVariant
  };
};
